import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '@app/services';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-password-changed',
  templateUrl: './password-changed.component.html',
  styleUrls: ['./password-changed.component.scss'],
  imports: [MatButton],
})
export class PasswordChangedComponent implements OnInit {
  constructor(
    private loginService: LoginService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (this.loginService.user) {
      this.router.navigate(['/']);
    }
  }

  login() {
    this.loginService.login('/');
  }
}
